export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-gradient-to-br from-amber-100 to-orange-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-700 inline-block">
              關於我們
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollTo("about")}
                  className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer"
                >
                  公司簡介
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  資質認證
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  合作夥伴
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  新聞動態
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-700 inline-block">
              產品與服務
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollTo("products")}
                  className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer"
                >
                  熱帶水果
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollTo("process")}
                  className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer"
                >
                  出口服務
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  定制包裝
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  冷鏈物流
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-700 inline-block">
              客戶支持
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  常見問題
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollTo("process")}
                  className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer"
                >
                  訂購流程
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer">
                  售後服務
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollTo("contact")}
                  className="text-gray-600 hover:text-orange-700 transition-colors text-sm cursor-pointer"
                >
                  在線諮詢
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-gray-900 mb-4 pb-2 border-b-2 border-orange-700 inline-block">
              聯繫我們
            </h3>
            <ul className="space-y-3">
              <li className="text-gray-600 text-sm">
                <i className="ri-phone-line mr-2"></i>+84 33 838 9340
              </li>
              <li className="text-gray-600 text-sm">
                <i className="ri-mail-line mr-2"></i>export@farmersbasket.vn
              </li>
              <li className="text-gray-600 text-sm">
                <i className="ri-map-pin-line mr-2"></i>Ho Chi Minh City, Vietnam
              </li>
              <li className="text-gray-600 text-sm">
                <i className="ri-time-line mr-2"></i>週一至週五 8:00-18:00
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-orange-200 pt-12 pb-8">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div>
              <div className="text-4xl lg:text-5xl font-bold text-gray-900 mb-2">VIETNAM FRUITS</div>
              <div className="flex items-center space-x-4">
                <div className="h-0.5 w-12 bg-orange-700"></div>
                <span className="text-sm text-gray-600 italic">Fresh from Vietnam to the World</span>
              </div>
            </div>
            <div className="text-center lg:text-right space-y-4">
              <div className="text-sm text-gray-600">© 2025 Farmer&apos;s Basket. All rights reserved.</div>
              <div className="flex justify-center lg:justify-end space-x-4">
                {[
                  { icon: "ri-facebook-fill" },
                  { icon: "ri-instagram-line" },
                  { icon: "ri-linkedin-fill" },
                  { icon: "ri-whatsapp-line" },
                ].map((s, i) => (
                  <a
                    key={i}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center bg-orange-700 text-white rounded-full hover:bg-orange-800 transition-colors cursor-pointer"
                  >
                    <i className={s.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
